import { Link } from 'react-router-dom';
import {
  lifecycleLabel,
  pointOfSaleLabel,
} from '../../materiels/materielDisplayMaps';

/**
 * Onglet Affectation — lecture seule, lien par nom uniquement.
 */
export default function MaterielDrawerAssignTab({ item, loading }) {
  if (loading) {
    return (
      <div className="space-y-3 p-1">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-8 rounded bg-gray-100 animate-pulse" />
        ))}
      </div>
    );
  }

  if (!item) {
    return (
      <p className="text-sm text-gray-500">Affectation indisponible.</p>
    );
  }

  const isAssigned =
    item.status === 'AFFECTE' && Boolean(item.commercant?.nom?.trim());
  const pdvName = pointOfSaleLabel(item);
  const hasLink = Boolean(item.commercant?.nom?.trim() && item.commercantId);

  return (
    <div className="space-y-4">
      <div
        className={`rounded-md border px-3 py-2 text-sm ${
          isAssigned
            ? 'border-primary-200 bg-primary-50/50 text-primary-900'
            : 'border-amber-200 bg-amber-50 text-amber-950'
        }`}
      >
        {isAssigned
          ? 'Ce matériel est affecté à un point de vente.'
          : 'Ce matériel n’est pas affecté à un point de vente.'}
      </div>

      <dl className="space-y-3">
        <div>
          <dt className="text-xs text-gray-500">Point de vente</dt>
          <dd className="mt-0.5 text-sm font-medium text-gray-900">
            {hasLink ? (
              <Link
                to={`/commercants/${item.commercantId}`}
                className="text-primary-700 hover:underline"
              >
                {pdvName}
              </Link>
            ) : (
              pdvName
            )}
          </dd>
        </div>
        <div>
          <dt className="text-xs text-gray-500">Cycle de vie</dt>
          <dd className="mt-0.5 text-sm text-gray-900">
            {lifecycleLabel(item.status)}
          </dd>
        </div>
      </dl>
    </div>
  );
}
